import { DELETE_TOKEN } from '../../mutation-types';

const mutations = {
  [DELETE_TOKEN]() {
    window.localStorage.removeItem('token');
  },
};

export default mutations;
